import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 100);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'About', href: '#about' },
    { name: 'The Chef', href: '#chef' },
    { name: 'Menu', href: '#menu' },
    { name: 'Experience', href: '#experience' },
    { name: 'Contact', href: '#contact' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled
          ? 'bg-white/95 backdrop-blur-md py-3 shadow-lg'
          : 'bg-transparent py-4'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between">
          {/* Desktop Navigation - always centered */}
          <nav className="hidden md:flex items-center gap-8 mx-auto">
            <a
              href="https://crispy-franchise.emergent.host"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="nav-franchising-btn"
              className="bg-[#c9a962] text-[#1e1919] px-6 py-2.5 text-sm font-semibold rounded transition-all duration-300 hover:bg-[#61525a] hover:text-white hover:shadow-lg hover:shadow-[#c9a962]/20"
            >
              Franchising
            </a>
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                className={`text-sm font-medium tracking-wide transition-all duration-300 hover:text-[#c9a962] ${
                  isScrolled ? 'text-[#1e1919]' : 'text-[#1e1919]'
                }`}
              >
                {link.name}
              </a>
            ))}
            <a
              href="#contact"
              className="bg-[#c9a962] text-[#1e1919] px-6 py-2.5 text-sm font-semibold rounded transition-all duration-300 hover:bg-[#61525a] hover:text-white hover:shadow-lg hover:shadow-[#c9a962]/20"
            >
              Order Now
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden ml-auto p-2 text-[#1e1919] transition-colors"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        <div
          className={`md:hidden absolute left-0 right-0 top-full bg-white transition-all duration-300 overflow-hidden shadow-xl border-t border-[#e8e3db] ${
            isMobileMenuOpen ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'
          }`}
        >
          <nav className="flex flex-col py-6 px-6 gap-1">
            <a
              href="https://crispy-franchise.emergent.host"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="nav-franchising-btn-mobile"
              className="mb-2 bg-[#c9a962] text-[#1e1919] px-6 py-3 text-center font-semibold rounded transition-all duration-300 hover:bg-[#61525a] hover:text-white"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Franchising
            </a>
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                className="text-[#1e1919] py-3 px-4 text-base font-medium hover:bg-[#f8f8f8] rounded-lg transition-colors"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                {link.name}
              </a>
            ))}
            <a
              href="#contact"
              className="mt-4 bg-[#c9a962] text-[#1e1919] px-6 py-3 text-center font-semibold rounded transition-all duration-300 hover:bg-[#61525a] hover:text-white"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Order Now
            </a>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
